export const ERROR_CONTEXT = {
  context: 'withdraw',
};
